import 'url-polyfill';

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'tanok';
import { t } from 'c-3po';

import { toJS } from '../../helpers/ImmutableToJS';

import { getAnalcsSocialActName } from '../../../libs/helpers/prom';

// images
import SocialFacebookSvg from './images/socialFacebook.svg';
import SocialGoogleSvg from './images/socialGoogle.svg';

// styles
import css from './social.sss';


const SocialView = (props) => {
    const { sendAnaliticsAction, socialLinks } = props;

    return (
        <ul className={css.root}>
            {socialLinks.map((socialObj) => {

                let imageSrc;
                let linkText;

                switch (socialObj.name) {
                    case 'facebook':
                    case 'fb':
                        imageSrc = SocialFacebookSvg;
                        linkText = t`Войти через Facebook`;
                        break;
                    case 'google':
                    case 'gl':
                        imageSrc = SocialGoogleSvg;
                        linkText = t`Войти через Google`;
                        break;
                    default:
                        imageSrc = null;
                        linkText = '';
                }
                const link = new URL(socialObj.link);
                link.searchParams.append('next', window.location.href);

                return linkText ? (
                    <li className={css.item} key={socialObj.name}>
                        <a
                            href={link.toString()}
                            name={socialObj.name}
                            className={css.link}
                            data-qaid='social_btn'
                            onClick={sendAnaliticsAction(getAnalcsSocialActName(
                                socialObj.name
                            ))}
                        >
                            <img
                                className={css.icon}
                                src={imageSrc}
                                alt={socialObj.name}
                            />
                            <span>{linkText}</span>
                        </a>
                    </li>
                ) : null;
            })}
        </ul>
    );
};

SocialView.propTypes = {
    socialLinks: PropTypes.any,
    sendAnaliticsAction: PropTypes.func,
};

const mapStateToProps = (state) => ({
    socialLinks: state.get('socialLinks'),
});

export const Social = connect(mapStateToProps)(toJS(SocialView));
